import React from "react";

export default class CatPlaceLoader extends React.PureComponent {
  render() {
    const rows = [];
    for (let i = 0; i < 15; i++) {
      rows.push(
        <div key={i} className="placeholder-row">
          <div className="placeholder-square"></div>
          <div className="placeholder-square"></div>
          <div className="placeholder-square"></div>
        </div>
      );
    }

    return (
      <div className="placeholder-container">
        <style>
          {`
            @keyframes placeholderShimmer {
              0% {
                background-position: -468px 0;
              }
              100% {
                background-position: 468px 0;
              }
            }

            .placeholder-container {
              display: flex;
              flex-direction: column;
              justify-content: start;
              align-items: center;
            }

            .placeholder-row {
              display: flex;
              justify-content: space-between;
              margin: 10px 0; 
            }

            .placeholder-square {
              width: 100px; 
              height: 100px; 
              background-color: #e0e0e0; 
              background-image: linear-gradient(to right, #e0e0e0 0%, #c8c8c8 20%, #e0e0e0 40%, #e0e0e0 100%);
              background-repeat: no-repeat;
              background-size: 800px 104px;
              display: inline-block;
              position: relative;
              overflow: hidden;
              box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
              margin: 0 5px; 
              animation-duration: 1.5s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
              animation-name: placeholderShimmer;
              animation-timing-function: linear;
            }
          `}
        </style>
        {rows}
      </div>
    );
  }
}